import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const BlogGetListNews = createAsyncThunk(
  "BlogGetListNews",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.BLOG.GET_LIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  BlogGetListNewsData: {
    data: null,
    error: null,
  },
};

const BlogSlice = createSlice({
  name: "BLOG",
  initialState,
  reducers: {
    // setLoader: (state, action) => {
    //   state.isLoading = action.payload;
    // },
    //   setWorkFlowGetListData: (state) => {
    //     state.WorkFlowGetListData.data = null;
    //   },
    setBlogGetListNewsData: (state) => {
      state.BlogGetListNewsData.data = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(BlogGetListNews.fulfilled, (state, action) => {
        state.BlogGetListNewsData.data = action.payload;
      })
      .addCase(BlogGetListNews.rejected, (state, action) => {
        state.BlogGetListNewsData.error = action.error.message;
      });
  },
});

export const { setBlogGetListNewsData } = BlogSlice.actions;
export default BlogSlice.reducer;
